import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function SimplePage({ title, body }) {
  return (
    <div className="pt-24">
      <section className="bg-forest-950 py-28">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <p className="text-sage-400 tracking-[0.3em] text-xs uppercase mb-5">Perrin Myddelton</p>
          <h1 className="font-serif text-cream-50 text-5xl md:text-7xl leading-tight">{title}</h1>
          <p className="mt-6 text-cream-100/75 text-lg max-w-2xl">{body}</p>
          <p className="mt-6 text-cream-100/60 text-sm italic">This page is coming soon.</p>
          <Link to="/contact" className="mt-10 inline-flex items-center gap-3 bg-sage-500 text-forest-900 px-8 py-4 text-sm font-medium tracking-wide hover:bg-sage-600 transition-colors">Contact Us <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
